module.exports = __webpack_public_path__ + "img/cartao.3fc66caf.svg";